@use "../../styling/colors.scss" as *;
@use "../../styling/typography.scss" as *;

.DefinitionList {
  @extend %font-family-primary;

  font-size: $font-size-normal;
  gap: 8px;
  display: grid;
  color: $theme-color-text;
  margin: 0; // override HTMl default
  align-items: baseline;

  a {
    color: $theme-color-links;

    &:hover {
      color: $theme-color-hover;
    }
  }

  dt {
    font-weight: $font-weight-semibold;
    margin: 0;
  }

  dd {
    margin: 0;
    word-break: break-word; // fixes AUB-9365
  }

  &.beside {
    grid-template-columns: auto 1fr;
    align-items: center;
  }

  &.bordered {
    grid-template-columns: 1fr;
    border: 1px solid $theme-color-borders;
    border-radius: 6px;
    gap: 0;

    dd,
    dt {
      display: block;
      padding-left: 1em;
      padding-right: 1em;
    }

    dt {
      padding-top: 1em;
      border-top: 1px solid $theme-color-borders;

      &:first-child {
        border-top: none;
      }
    }

    dd {
      padding-bottom: 1em;
    }
  }

  &.below {
    grid-template-columns: 1fr;

    // stylelint-disable no-descending-specificity
    dd,
    dt {
      display: block;
    }

    dd {
      margin-bottom: 1em;

      &:last-child {
        margin-bottom: 0;
      }
    }
  }

  &.contrastOnValue {
    grid-template-columns: auto 1fr;
    gap: 20px;

    *:not(dd)>dt {
      color: $theme-color-text;
    }

    dt {
      color: $color-grey-B;
    }

    dd {
      width: 98%;
    }
  }

  &.contrastOnValueWider {
    grid-template-columns: auto 1fr;
    gap: 41px;

    *:not(dd)>dt {
      color: $theme-color-text;
    }

    dt {
      color: $color-grey-B;
    }

    dd {
      width: 98%;
    }
  }

  &.contrastOnKey {
   grid-template-columns: auto 1fr;

   dt {
      font-weight: bold;
   }
  }

  &.contrastOnKeyValue {
    grid-template-columns: auto 1fr;
    align-items:last baseline;

    dt, dd {
      color: $color-grey-B;

      &:first-of-type {
        font-weight: bold;
      }
    }
  }

  &.belowContrastOnValue {
    grid-template-columns: 1fr;
    gap: 0;

    // stylelint-disable no-descending-specificity
    dd,
    dt {
      display: block;
      color: $color-grey-B;
    }

    dd {
      margin-bottom: 1em;
      width: 98%;
      color: $theme-color-text;

      &:last-child {
        margin-bottom: 0;
      }
    }
  }
}
